import StatusIconRenderer from '../../StatusIconRenderer';
import { ServiceCodes } from '../../billings/claims/constants';

import type { SupervisionNoteStatus } from '../../../../constants';

export const assessmentHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: SupervisionNoteStatus) => {
        return <StatusIconRenderer procedureCode={ServiceCodes.AssessmentCode} status={value} />;
      },
    },
  },
  {
    name: 'client',
    label: 'Client',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'assessment_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'start_date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'time',
    label: 'Time',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'service_code',
    label: 'Service code',
    options: {
      filter: false,
      sort: true,
    },
  },
];
